import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useDividendsAndInterest = (
  businessId: string,
): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.Custodian);

  return useQuery(
    [ReactQueryKeys.DividendsAndInterest, businessId],
    async () => {
      const response = await treasureApi().get(
        `/business/${businessId}/returns/dividends-and-interest`,
      );

      // Defensively normalize nullable API numeric fields for downstream consumers.
      return (response.data.returns || []).map((item: any) => ({
        ...item,
        dividends: Number(item?.dividends || 0),
        interest: Number(item?.interest || 0),
        fees: Number(item?.fees || 0),
      }));
    },
    {
      enabled: !!businessId,
    },
  );
};
